import {
    CREATE_TICKET,
    LIST_ISSUE_SPECIFIC_ACTIONS,
    LIST_ISSUE_SPECIFIC_TASKS,
    LIST_TICKET_ISSUES,
    LIST_TICKETS,
    PREVIEW_TICKET_FILE,
    FETCH_ORDER_INFO,
    STORE_ORDER_INFO_FETCH,
    STORE_TICKET_ACTION_TASKS,
    STORE_TICKET_ACTIONS,
    STORE_TICKET_ISSUES,
    STORE_TICKETS,
    STORE_UPDATED_TICKET,
    STORE_TICKET_SETTINGS,
    STORE_UPDATED_TICKET_WITH_PREVIEW,
    UPDATE_TICKET,
    UPDATE_TICKET_SETTINGS,
    DELETE_TICKET,
    GET_TICKET_SETTINGS,
    LIST_STATUS,
    STORE_STATUS,
    GENERATE_RETURN_REDIRECT,
    STORE_RETURN_REDIRECT,
    STORE_RETURN_REDIRECT_TRACKING_STATUS,
    RETURN_REDIRECT_TRACKING_STATUS,
    DELETE_RETURN_REDIRECT,
    CLEAR_RETURN_REDIRECT_TRACKING,
    CALCULATE_TICKET_REFUND_AMOUNT,
    STORE_TICKET_REFUND_AMOUNT, CLEAR_TICKET_REFUND_AMOUNT,
} from '../../constants/tickets';

export const listTickets = (data) => ({
    type: LIST_TICKETS,
    data
})

export const storeTickets = (tickets) => ({
    type: STORE_TICKETS,
    tickets
})

export const createTicket = (newTicket, reset) => ({
    type: CREATE_TICKET,
    newTicket,
    reset
});

export const storeUpdatedTicket = (updatedTicket) => ({
    type: STORE_UPDATED_TICKET,
    updatedTicket
})
export const storeTicketSettings = (ticketSettings) => ({
    type: STORE_TICKET_SETTINGS,
    ticketSettings
})

export const updateTicket = (updatedTicket) => ({
    type: UPDATE_TICKET,
    updatedTicket
})

export const updateticketSettings = (data) => ({
    type: UPDATE_TICKET_SETTINGS,
    data,
})

export const deleteTicket = (ticketId, callback) => ({
    type: DELETE_TICKET,
    ticketId,
    callback
})

export const getTicketSettings = () => ({
    type: GET_TICKET_SETTINGS,
})

export const storeTicketActions = (ticketActions) => ({
    type: STORE_TICKET_ACTIONS,
    ticketActions
})

export const listStatus = () => ({
    type: LIST_STATUS
})

export const storeStatus = (status) => ({
    type: STORE_STATUS,
    status
})

export const listTicketIssues = () => ({
    type: LIST_TICKET_ISSUES
})

export const storeTicketIssues = (ticketIssues) => ({
    type: STORE_TICKET_ISSUES,
    ticketIssues
})

export const storeTicketActionTasks = (ticketActionTasks) => ({
    type: STORE_TICKET_ACTION_TASKS,
    ticketActionTasks
})



export const listIssueSpecificActions = (ticketIssueId) => ({
    type: LIST_ISSUE_SPECIFIC_ACTIONS,
    ticketIssueId
});

export const listIssueSpecificTasks = (ticketIssueId) => ({
    type: LIST_ISSUE_SPECIFIC_TASKS,
    ticketIssueId
});



export const previewTicketFile = (previewRequest,callback) => ({
    type: PREVIEW_TICKET_FILE,
    previewRequest,callback
});

export const storeUpdatedTicketWithPreview = (updatedTicket)=>({
    type: STORE_UPDATED_TICKET_WITH_PREVIEW,
    updatedTicket
})

export const fetchOrderInfo = (orderInfo, orderId, originalTrackingId) => ({
    type: FETCH_ORDER_INFO,
    orderInfo,
    orderId,
    originalTrackingId
})

export const storeOrderInfoFetch = (orderInfoFetch) => ({
    type: STORE_ORDER_INFO_FETCH,
    orderInfoFetch
})

export const generateReturnRedirect = (data,callback) => ({
    type: GENERATE_RETURN_REDIRECT,
    data,
    callback
})

export const deleteReturnRedirect = (data,callback) => ({
    type: DELETE_RETURN_REDIRECT,
    data,
    callback
})

export const storeReturnRedirect = (data) => ({
    type: STORE_RETURN_REDIRECT,
    data
})

export const returnRedirectTrackingStatus = (data) => ({
    type: RETURN_REDIRECT_TRACKING_STATUS,
    data
})

export const clearReturnRedirectTrackingNumber = (index) => ({
    type: CLEAR_RETURN_REDIRECT_TRACKING,
    index
})

export const storeReturnRedirectTrackingStatus = (data) => ({
    type: STORE_RETURN_REDIRECT_TRACKING_STATUS,
    data
})
export const calculateTicketRefundAmount = (index, data) => ({
    type: CALCULATE_TICKET_REFUND_AMOUNT,
    index,
    data
})

export const storeTicketRefundAmount = (index, refundAmount, refundDetails) => ({
    type: STORE_TICKET_REFUND_AMOUNT,
    index,
    refundAmount,
    refundDetails
})

export const clearTicketRefundAmount = (index) => ({
    type: CLEAR_TICKET_REFUND_AMOUNT,
    index
})
